import axios, { AxiosRequestConfig } from "axios";
import { getAxiosError } from "../common/utils";
import {
    BASE_URL,
    API_URLS
} from '../common/constants'

const getBaseURL = (migrationPlatform: string) => {
    return API_URLS[migrationPlatform.toUpperCase() as keyof typeof API_URLS]
}

class NetworkService {

    static superPost(url: string, migrationPlatform: string, params: Object) {
        if (navigator.onLine) {
            let baseURL = getBaseURL(migrationPlatform)
            let _axios = NetworkService.getAxiosInstance(baseURL);
            return _axios.post(url, params)
                .then(function (success) {
                    return Promise.resolve(success);
                }).catch(function (failure) {
                    return Promise.reject(failure);
                })
        } else {
            return Promise.reject("You are offline.");
        }
    }

    static superGet(url: string, migrationPlatform: string, params: Object) {
        if (navigator.onLine) {
            let baseURL = getBaseURL(migrationPlatform)
            let _axios = NetworkService.getAxiosInstance(baseURL);
            return _axios.get(url, params)
                .then(function (success) {
                    return Promise.resolve(success);
                }).catch(function (failure) {
                    return Promise.reject(failure);
                })
        } else {
            return Promise.reject("You are offline.");
        }
    }

    static post(url: string, params: Object, config?: AxiosRequestConfig) {
        if (navigator.onLine) {
            let _axios = NetworkService.getAxiosInstance();
            return _axios.post(url, params, config)
                .then(function (success) {
                    return Promise.resolve(success);
                }).catch(function (failure) {
                    return Promise.reject(failure);
                })
        } else {
            return Promise.reject("You are offline.");
        }
    }

    static get(url: string, params: Object) {
        if (navigator.onLine) {
            let _axios = NetworkService.getAxiosInstance();
            return _axios.get(url, params)
                .then(function (success) {
                    return Promise.resolve(success);
                }).catch(function (error) {
                    return Promise.reject(error);
                })
        } else {
            return Promise.reject("You are offline");
        }

    }

    static put(url: string, params: Object) {
        if (navigator.onLine) {
            let _axios = NetworkService.getAxiosInstance();
            return _axios.put(url, params)
                .then(function (success) {
                    return Promise.resolve(success);
                }).catch(function (error) {
                    return Promise.reject(error);
                })
        } else {
            return Promise.reject("You are offline");
        }

    }

    static delete(url: string, params: Object) {
        if (navigator.onLine) {
            let _axios = NetworkService.getAxiosInstance();
            return _axios.delete(url, { data: params })
                .then(function (success) {
                    return Promise.resolve(success);
                }).catch(function (error) {
                    return Promise.reject(error);
                })
        } else {
            return Promise.reject("You are offline");
        }
    }

    static getAxiosInstance(baseURL: string = BASE_URL) {
        let googleToken =  localStorage.getItem('google-token')
        let accessToken =  localStorage.getItem('access-token')
        let companyId = localStorage.getItem('company-id');
        let userId = localStorage.getItem('user-id');
        let user = localStorage.getItem('email');
        let company = localStorage.getItem('company');
        let supportUserIdOfSelectedCompany = localStorage.getItem('supportUserIdOfSelectedCompany');
        let timezoneName = (new Date()).toTimeString().split('(').pop();
        timezoneName = timezoneName?.substring(
            timezoneName.length - 1
        );
        let timezoneCode = (new Date()).toTimeString().match(
            new RegExp("[A-Z](?!.*[(])", "g")
        )?.join('');
        let timezoneOffset = new Date().getTimezoneOffset();
        let headers = {
          "access-token": accessToken,
          "company-id": companyId,
          "user-id": userId,
          user: user,
          company: company,
          "Content-Type": "application/json",
          "request-from": "SRP",
          timezoneName,
          timezoneCode,
          "timezone-offset": timezoneOffset,
          "support-user-id": supportUserIdOfSelectedCompany,
          "google-token" : googleToken,
        };
        let instance = axios.create({
            baseURL,
            headers: headers
        });
        instance.interceptors.response.use(function (response) {
            if ((typeof(response.status) === 'string' && 
                    response.status === "success") || 
                response.status === 200) {
                let { data } = response;
                let { result } = data;
                return result || data;
            } else {
                return response;
            }
        }, function (error) {
            if (error.response) {
                let response = error.response;
                if (response.status === 401) {
                    localStorage.clear();
                    sessionStorage.setItem(
                        "auth-expired-message",
                        "Your token has expired. Please log in again."
                    );
                    if (window.location.pathname !== "/login") {
                        window.location.href = "/login";
                    } else {
                        window.location.reload();
                    }
                }
                throw getAxiosError(error);
            } else if (error.request) {
                console.log("Offline!");
                throw error.request;
            } else {
                throw error;
            }
        });
        return instance;
    }
}

export default NetworkService;
